import angular from 'angular';
import { AcknowledgedModifiedTimeEntryAuditLogComponent } from './acknowledged-modified-time-entry-audit-log.component';
import { AuditLogHistoryEntryModalComponent } from './audit-log-entry-history-modal.component';
import { CorporationAuditLogPickerComponent } from './corporation-audit-log-picker.component';
import { EmployeeAuditLogPickerComponent } from './employee-audit-log-picker.component';
import { EmployeeTimekeepingAuditLogComponent } from './employee-timekeeping-audit-log.component';
import { TimeEntryModificationAuditLogComponent } from './time-entry-modification-audit-log.component';

export const AuditingModule = angular
    .module("apex.mainApp.auditing", [])
    .component("apexAuditLogHistoryEntryModal", AuditLogHistoryEntryModalComponent)
    .component("apexAcknowledgedModifiedTimeEntryAuditLog", AcknowledgedModifiedTimeEntryAuditLogComponent)
    .component("apexCorporationAuditLogPicker", CorporationAuditLogPickerComponent)
    .component("apexEmployeeAuditLogPicker", EmployeeAuditLogPickerComponent)
    .component("apexEmployeeTimekeepingAuditLog", EmployeeTimekeepingAuditLogComponent)
    .component("apexTimeEntryModificationAuditLog", TimeEntryModificationAuditLogComponent)
    .name;
